import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-items-center tw-gap-[4px]" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "tw-text-sm tw-font-[700] tw-tracking-[0.15px] tw-leading-[24px] tw-text-[#4A92E5]" }

import personSvg from "@/core/uni-assets/svgs/person.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeType',
  props: {
  value: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(personSvg),
      width: "16px",
      height: "16px"
    }, null, 8, _hoisted_2),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.value ?? "N/A"), 1)
  ]))
}
}

})